export function asIdentifier(value) {
    if (value.trim().length === 0) {
        throw new Error("Identifiers must not be empty.");
    }
    return value;
}
